import React, { lazy } from "react";
import Page from "components/Page";
import { Props } from "./Managers";

const Managers = lazy(() => import("./Managers"));

export default (props: Props) => (
  <Page>
    <Managers {...props} />
  </Page>
);
